"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelector = exports.useDispatch = exports.default = exports.LocaleContext = exports.ConfigContext = exports.AppFrameContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
const AppFrameContext = exports.AppFrameContext = _react.default.createContext(null);
const ConfigContext = exports.ConfigContext = _react.default.createContext({});
const LocaleContext = exports.LocaleContext = _react.default.createContext({});
const useDispatch = exports.useDispatch = (0, _reactRedux.createDispatchHook)(AppFrameContext);
const useSelector = exports.useSelector = (0, _reactRedux.createSelectorHook)(AppFrameContext);
var _default = exports.default = AppFrameContext;